import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

const fb = require('./firebaseConfig.js')
const config = require('./config.js')

Vue.use(VueAxios, axios)
Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(user => {
    console.debug('User State Changed: ' + JSON.stringify(user))
    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('fetchUserOrganization')
        store.dispatch('fetchUserRole')
        store.dispatch('updateIsMfaEnrolled')
        store.dispatch('includeStripe')
    }
})

// handle id token refresh
fb.auth.onIdTokenChanged(user => {
    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('fetchUserOrganization')
        user.getIdToken(false).then(idToken => {
            console.debug('User Id Token Changed: ' + JSON.stringify(idToken))
            store.commit('setCurrentUserIdToken', idToken)
            store.dispatch('updateIsMfaEnrolled')
            store.dispatch('fetchUserRole')
        })
    }
})

export const store = new Vuex.Store({
    state: {
      currentUser: null,
      currentUserIdToken: null,
      mfaEnrolled: false,
      mfaPhoneNumber: null,
      userOrganization: null,
      userRole: null,
      stripeAPIKey: config.CONSTANTS.STRIPE_PUBLIC_KEY,
      stripe: null
    },
    actions: {
        clearData ({ commit }) {
            commit('setCurrentUser', null)
            commit('setCurrentUserIdToken', null)
            commit('setMfaEnrolled', false)
            commit('setMfaPhoneNumber', null)
            commit('setUserOrganization', null)
            commit('setUserRole', null)
        },
        fetchUserOrganization ({ commit, state }) {
            state.currentUser.getIdTokenResult().then(idTokenResult => {
                commit('setUserOrganization', idTokenResult.claims.organization)
            })
        },
        fetchUserRole ({ commit, state }) {
            state.currentUser.getIdTokenResult().then(idTokenResult => {
                commit('setUserRole', idTokenResult.claims.role)
            })
        },
        updateIsMfaEnrolled ({ commit, state }) {
            if (state.currentUser.multiFactor.enrolledFactors.length > 0 &&
                state.currentUser.multiFactor.enrolledFactors[0].factorId === 'phone') {
                console.debug('User is MFA enrolled.')
                commit('setMfaEnrolled', true)
                commit('setMfaPhoneNumber', state.currentUser.multiFactor.enrolledFactors[0].phoneNumber)
            } else {
                commit('setMfaEnrolled', false)
                commit('setMfaPhoneNumber', null)
            }
        },
        includeStripe ({ commit, state }) {
            let documentTag = document
            let tag = 'script'
            let object = documentTag.createElement(tag)
            let scriptTag = documentTag.getElementsByTagName(tag)[0]
            object.src = '//js.stripe.com/v3/'
            object.addEventListener('load', () => {
              // eslint-disable-next-line no-undef
              var stripe = Stripe(state.stripeAPIKey)
              commit('setStripe', stripe)
            }, false)
            scriptTag.parentNode.insertBefore(object, scriptTag)
        }
    },
    mutations: {
        setCurrentUser (state, val) {
          state.currentUser = val
        },
        setCurrentUserIdToken (state, val) {
          state.currentUserIdToken = val
        },
        setMfaEnrolled (state, val) {
          state.mfaEnrolled = val
        },
        setMfaPhoneNumber (state, val) {
          state.mfaPhoneNumber = val
        },
        setUserOrganization (state, val) {
          state.userOrganization = val
        },
        setUserRole (state, val) {
          state.userRole = val
        },
        setStripe (state, val) {
          state.stripe = val
        }
    }
})